/** useFatture + markFatturata mutation — F-011 (rescoped) admin. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import {
  listFatture,
  markFatturata,
  errorMessageFor,
  type FattureListResponse,
  type ListFattureFilters,
  type MarkFatturataBody,
} from '../lib/fatture-client';
import { fattureQueryKey } from '../lib/query-client';

export function useFatture(filters: ListFattureFilters) {
  return useQuery<FattureListResponse>({
    queryKey: fattureQueryKey({ stato: filters.stato, page: filters.page }),
    queryFn: () => listFatture(filters),
  });
}

export function useMarkFatturata() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: string; body: MarkFatturataBody }) =>
      markFatturata(vars.id, vars.body),
    onSuccess: () => {
      toast.success('Voce marcata come fatturata.');
      void qc.invalidateQueries({ queryKey: ['admin', 'fatture'] });
    },
    onError: (err) => toast.error(errorMessageFor(err)),
  });
}
